import React, {useState} from 'react';
import {Image, StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import {HEADING_BORDER_WIDTH, HEADING_FONT_SIZE} from "../../Config/Constants";
import {BORDER_COLOR, HEADING_TITLE_COLOR} from "../../Config/Colors";
import Checkbox from "expo-checkbox";
import OrderIcon from "../../Images/Icons/order.png";
import HeaderTypes from "../../Domain/Types/HeaderTypes";
import {powerClientRepository} from "../../Domain/Repositories/PowerClientRepository";
import {HEADER_TITLES} from "../../Config/Translations";

interface ListHeaderProps
{
    onCheckboxSelected?: (state: boolean) => void;
}

const headerItems = [
    HeaderTypes.None,
    HeaderTypes.ClientName,
    HeaderTypes.ConnectionStatus,
    HeaderTypes.ProxyName,
    HeaderTypes.None,

];

const flex = [0.17, 1, 1, 1, 0.17];

/**
 * Renders the List Header.
 */
export default function ListHeader({
    onCheckboxSelected,
}: ListHeaderProps)
{
    const [isChecked, setChecked] = useState(false);
    
    const onCheckboxValueChanged = (state: boolean): void =>
    {
        setChecked(state);
        
        if (onCheckboxSelected !== undefined)
        {
            onCheckboxSelected(state);
        }
    }
    
    const getHeaderItems = (header: HeaderTypes, index: number): JSX.Element =>
    {
        if (index === 0)
        {
            return (
                <Checkbox
                    style={styles.checkBox}
                    value={isChecked}
                    onValueChange={onCheckboxValueChanged}
                />
            );
        }
        
        return (
            <View style={styles.textHeaderContainer}>
                <View style={styles.textHeaderView}>
                    <Text style={styles.headingText}>
                        {HEADER_TITLES(header)}
                    </Text>
                </View>

                {header !== HeaderTypes.None && (
                    <View style={styles.orderByView}>
                        <TouchableOpacity
                            style={styles.orderByButton}
                            onPress={() => {
                                powerClientRepository.updateOrder(header);
                            }}
                        >
                            <Image
                                source={OrderIcon}
                                resizeMode={"contain"}
                                style={styles.icon}
                            />
                        </TouchableOpacity>
                    </View>)}
            </View>
        );
    }
    
    const renderHeaderItems = (): JSX.Element[] =>
    {
        return headerItems.map((header: HeaderTypes, index: number) =>
        {
            return (
                <View
                    style={[styles.headingTextView, {
                        flex: flex[index],
                    }]}
                    key={`${header}-${index}`}
                >
                    {getHeaderItems(header, index)}
                </View>
            )
        })
    }
    return (
        <View style={styles.header}>
            {renderHeaderItems()}
        </View>
    );
}

const styles = StyleSheet.create({
    header: {
        flexDirection: 'row',
        width: '100%',
        flex: 0.09,
    },
    headingTextView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: BORDER_COLOR,
        borderColor: BORDER_COLOR,
        borderWidth: HEADING_BORDER_WIDTH,
    },
    headingText: {
        color: HEADING_TITLE_COLOR,
        fontSize: HEADING_FONT_SIZE,
        fontWeight: "600",
        textAlign: 'left',
        paddingLeft: '5%',
        width: '100%',
    },
    checkBox: {
        width: '55%',
        height: undefined,
        aspectRatio: 1,
    },
    textHeaderContainer: {
        width: '100%',
        height: '100%',
        flexDirection: 'row',
    },
    textHeaderView: {
        flex: 5,
        height: '100%',
        justifyContent: 'center',
    },
    orderByView: {
        flex: 1,
        height: '100%',
        justifyContent: 'center',
    },
    orderByButton: {
        width: '100%',
        height: undefined,
        aspectRatio: 1,
        justifyContent: 'center',
    },
    icon: {
        width: undefined,
        height: '40%',
        aspectRatio: 1,
        alignSelf: 'center',
    },
});
